<template>
  <div class="apply_container">
    <div class="navbar">
      <span>入馆预约</span>
      <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
    </div>
    <div class="apply_content">
      <div class="tips-header">
        <img src="@/assets/images/detail/status.png" alt="" class="tips-img" />
        <div class="tips-title">预约成功</div>
        <div class="btns">
          <div class="btn tips-back" @click="back">返回</div>
          <div class="btn tips-look" @click="goMyOrder">查看预约</div>
        </div>
      </div>
      <div class="QRCode dashed-box" v-if="detailInfo.length > 0">
        <div class="title">{{ detailInfo[0].venueName || venueName }}</div>
        <div class="address">
          <img src="@/assets/images/detail/performance/location.png" alt="" class="address-icon" />
          <div class="address-text">
            <span class="detail">地址：{{ detailInfo[0].address || address }}</span>
            <span class="shuline">|</span>
            <span>{{ detailInfo[0].distance || distance | setMorKm }}km</span>
          </div>
        </div>
        <div>
          <div class="navigation-btn" @click="UNInavigation">
            <img src="@/assets/images/detail/daoh-icon.png" alt="" class="navigation-icon" />
            <span>导航</span>
          </div>
        </div>
        <div class="QRCode-content">
          <div class="name" v-if="detailInfo.length == 1">{{ detailInfo[userIndex].contactName }}</div>
          <div class="d-f ai-c jc-c names" v-if="detailInfo.length > 1">
            <div class="name_item" :class="index == userIndex ? 'active' : ''" v-for="(item, index) in detailInfo" @click="selectUser(item, index)">{{ item.contactName }}</div>
          </div>
          <div class="code-img">
            <img :src="codeUrl[userIndex]" alt="" />
          </div>
          <div class="code-id">核销码：{{ detailInfo[userIndex].code }}</div>
          <div class="code-time">预约时间: {{ detailInfo[userIndex].rdate }} {{ detailInfo[userIndex].startTime }}-{{ detailInfo[userIndex].endTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode'
import { getVenueReservationList } from '@/api/venue'
export default {
  data() {
    return {
      id: '',
      codeUrl: [],
      detailInfo: {},
      userIndex: 0,
      venueName: '',
      address: '',
      distance: '',
    }
  },
  methods: {
    onSubmit() {},
    onConfirm() {},
    UNInavigation() {
      this.$myUni.postMessage({
        data: {
          methodsName: 'UNInavigation',
          data: {
            name: this.detailInfo[0].address,
            latitude: this.detailInfo[0].latitude,
            longitude: this.detailInfo[0].longitude,
          },
        },
      })
    },
    goMyOrder() {
      if (this.id) {
        this.$myUni.navigateTo({
          url: `/pages/mine/reservation?type=0`,
        })
      } else {
        this.$myUni.navigateTo({
          url: `/pages/mine/reservation?type=1`,
        })
      }
    },
    back() {
      this.$router.go(-2)
    },
    selectUser(item, index) {
      if (index !== this.userIndex) {
        this.userIndex = index
      }
    },
    getDetail() {
      getVenueReservationList({ reservationOrderId: this.id }).then((res) => {
        res.result.forEach((item, index) => {
          this.getCode(item.code, index)
        })
        this.detailInfo = res.result

        console.log('codeurl====>', this.codeUrl)
      })
    },
    async getCode(code, index) {
      let url = await QRCode.toDataURL(code)
      this.codeUrl[index] = url
      console.log('this.codeUrl====>', this.codeUrl)
    },
  },
  mounted() {
    const { id, venueName, address, distance } = this.$route.query
    if (id) {
      this.id = id
      this.venueName = venueName
      this.address = address
      this.distance = distance
      console.log(this.id)
      this.getDetail()
      this.getCode()
    }
  },
}
</script>
<style lang="scss">
.apply_container {
  width: 100%;
  height: 100vh;
  background: #fff;

  .navbar {
    z-index: 10;
    width: 100%;
    height: 44px;
    position: fixed;
    top: 40px;
    // top: calc(40px + env(safe-area-inset-top));
    left: 0;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    color: #112a26;
    font-size: 0.9rem;
    background: #fff;
    .back {
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 0.5rem;
    }
  }
  .apply_content {
    padding: 0 0.6rem;
    width: 100%;
    // height: calc(100% - 44px - env(safe-area-inset-top));
    height: calc(100% - 84px);

    position: absolute;
    // top: calc(44px + env(safe-area-inset-top));
    top: 84px;
    left: 0;
    overflow-y: auto;
    padding-bottom: calc(3rem + env(safe-area-inset-bottom));
  }
}
.apply_content {
  .header {
    margin: 16px 0 0;
    .name {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #212121;
      line-height: 28px;
    }
    .address {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 16px;
      display: flex;
      justify-content: start;
      align-items: center;
      margin-bottom: 14px;
      .address-icon {
        width: 14px;
        height: 14px;
      }
      .address-text {
        padding-left: 4px;
        width: 270px;
        display: flex;
        // justify-content: space-between;
        .detail {
          width: auto;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .shuline {
          padding: 0 4px;
        }
      }
      .arrow-icon {
        width: 24px;
        height: 24px;
        margin-left: 16px;
      }
    }
    .buildName {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #212121;
      line-height: 16px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f4f4f4;
      margin-bottom: 14px;
    }
  }
}
.tips-header {
  text-align: center;
  .tips-img {
    width: 5.2rem;
    height: 5.2rem;
    margin-top: 2rem;
  }
  .tips-title {
    margin-top: 0.4rem;
    font-size: 0.9rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #212121;
    text-align: center;
  }
  .btns {
    margin-top: 1.2rem;
    padding: 0 2.4rem;
    display: flex;
    justify-content: space-between;
    .btn {
      display: inline-block;
      width: 6.4rem;
      height: 2rem;
      border-radius: 1.1rem;
      border: 1px solid #a97048;
      line-height: 1.95rem;
      font-size: 0.8rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;

      color: #a97048;
      &.tips-look {
        background-color: #a97048;
        color: #fff;
        margin-left: 1.2rem;
      }
    }
  }
}
.QRCode {
  padding: 0.6rem;
  margin-top: 1.2rem !important;
}
.address {
  margin: 0.5rem 0;
  width: 100%;
  font-size: 0.6rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.8rem;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 0.7rem;
  .address-icon {
    width: 0.7rem;
    height: 0.7rem;
  }
  .address-text {
    padding-left: 0.2rem;
    width: 16rem;
    display: flex;
    // justify-content: space-between;
    .detail {
      width: auto;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .shuline {
      padding: 0 0.2rem;
    }
  }
  .arrow-icon {
    width: 1.2rem;
    height: 1.2rem;
    margin-left: 0.8rem;
  }
}
.navigation-btn {
  width: 3.6rem;
  height: 1.4rem;
  // background: #47988a;
  background: #a97048;
  border-radius: 0.7rem;
  font-size: 0.6rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  .navigation-icon {
    width: 0.9rem;
    height: 0.9rem;
    vertical-align: middle;
    margin-right: 0.1rem;
  }
}
.QRCode-content {
  text-align: center;
  border-top: 0.05rem solid #eee;
  margin-top: 0.6rem;
  .name {
    margin: 0.6rem 0 0.4rem;
    font-size: 0.7rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #212121;
  }
  .names {
    margin-top: 0.6rem;
    .name_item {
      // width: 3.2rem;
      padding: 0 0.55rem;
      height: 1.4rem;
      font-size: 0.7rem;
      color: #a97048;
      line-height: 1.4rem;
      background-color: rgba(248, 232, 213, 1);
      border: 0.05rem dashed #ccc;
      margin-right: 0.8rem;
      &.active {
        color: #fff;
        background: #a97048;
      }
    }
  }
  .code-img {
    width: 8rem;
    height: 8rem;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
      // background-color: #000;
    }
  }
  .code-id {
    font-size: 0.9rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #212121;
    line-height: 1.4rem;
    margin: 0.4rem 0;
  }
  .code-time {
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #212121;
  }
}
.dashed-box {
  margin-top: 0.8rem;
  background-color: #f7f7f7;
  border: 0.05rem dashed #ccc;
  .title {
    font-size: 0.9rem;
    font-weight: 600;
    color: #212121;
    line-height: 1.4rem;
  }
}
</style>
